module.exports = __webpack_public_path__ + "img/solution.883125aa.png";